import React, { useContext } from 'react';
import "../../../ui-styles/overlays/ConfirmationOverlay.css";
import {LangCtx} from "../../../lib/context";

const ConfirmationMsg = (props) => {
    const {l} = useContext(LangCtx);

    return (
        <div className="overlayAslt">
            <div className="circleOutline filled">
                <div className="tick"></div>
            </div>
            <span className="overMsg">{l.confApptTxt}</span>
        </div>
    )
}
export default ConfirmationMsg;